// import media from './Media'
// import textblock from './TextBlock'
// import poll from './Poll'
// import quote from './Quote'
// import flipcard from './FlipCard'
// import oembed from './oEmbed'
// import personalityquiz from './PersonalityQuiz'
// import trivia from './Trivia'
// import logicquiz from './LogicQuiz'
// import ctaform from './ctaForm'
// import ctabutton from './ctaButton'

const textblock = () => import(/* webpackChunkName:"textblock_v" */ './TextBlock.vue')
const media = () => import(/* webpackChunkName:"media_v" */ './Media.vue')
const oembed = () => import(/* webpackChunkName:"oembed_v" */ './oEmbed.vue')
const flipcard = () => import(/* webpackChunkName:"flipcard_v" */ './FlipCard.vue')
const poll = () => import(/* webpackChunkName:"poll_v" */ './Poll.vue')
const logicquiz = () => import(/* webpackChunkName:"logicquiz_v" */ './LogicQuiz.vue')
const quote = () => import(/* webpackChunkName:"quote_v" */ './Quote.vue')
const personalityquiz = () => import(/* webpackChunkName:"personalityquiz_v" */ './PersonalityQuiz.vue')
const personalityquizlist = () => import(/* webpackChunkName:"personalityquiz_v" */ './PersonalityQuizList.vue')
const trivia = () => import(/* webpackChunkName:"trivia_v" */ './Trivia.vue')
const trivialist = () => import(/* webpackChunkName:"trivia_v" */ './TriviaList.vue')
const ctaform = () => import(/* webpackChunkName:"ctaform_v" */ './ctaForm.vue')
const ctabutton = () => import(/* webpackChunkName:"ctabutton_v" */ './ctaButton.vue')

const modules = [
  {
    name: 'textblock',
    context: textblock
  },
  {
    name: 'poll',
    context: poll
  },
  {
    name: 'quote',
    context: quote
  },
  {
    name: 'flipcard',
    context: flipcard
  },
  {
    name: 'oembed',
    context: oembed
  },
  {
    name: 'media',
    context: media
  },
  {
    name: 'personalityquiz',
    context: personalityquiz
  },
  {
    name: 'trivia',
    context: trivia
  },
  {
    name: 'personalityquiz-list',
    context: personalityquizlist
  },
  {
    name: 'trivia-list',
    context: trivialist
  },
  {
    name: 'logicquiz',
    context: logicquiz
  },
  {
    name: 'ctaform',
    context: ctaform
  },
  {
    name: 'ctabutton',
    context: ctabutton
  }
]

export {
  modules
}
